import * as actionTypes from "../ActionTypes";

const initialState = {
  loading: false,
  saving: false,
  error: null,
  activeAgreements: [],
  agreements: [],
  analytics: { data: [], summary: null },
  entityAnalytics: { data: [], summary: null },
  consentUsers: [],
  consentUsersMeta: { page: 1, limit: 20, totalRecords: 0 },
  entityDetails: [],
  entityDetailsMeta: { page: 1, limit: 20, totalRecords: 0 },
};

const upsertByAgreementType = (list, item) => {
  if (!item) return list;
  const idx = list.findIndex(
    (a) => a?._id === item?._id || a?.agreementType === item?.agreementType
  );
  if (idx === -1) return [...list, item];
  return list.map((a, i) => (i === idx ? { ...a, ...item } : a));
};

const agreementsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.READ_ACTIVE_AGREEMENTS_REQUEST:
    case actionTypes.READ_AGREEMENTS_REQUEST:
    case actionTypes.READ_CONSENT_ANALYTICS_REQUEST:
    case actionTypes.READ_CONSENT_USERS_REQUEST:
    case actionTypes.READ_CONSENT_ENTITY_ANALYTICS_REQUEST:
    case actionTypes.READ_CONSENT_ENTITY_DETAILS_REQUEST:
      return { ...state, loading: true, error: null };

    case actionTypes.SAVE_AGREEMENT_REQUEST:
    case actionTypes.UPDATE_AGREEMENT_REQUEST:
    case actionTypes.DELETE_AGREEMENT_REQUEST:
    case actionTypes.SAVE_CONSENT_REQUEST:
      return { ...state, saving: true, error: null };

    case actionTypes.READ_ACTIVE_AGREEMENTS_SUCCESS:
      return { ...state, loading: false, activeAgreements: action.payload || [] };

    case actionTypes.READ_AGREEMENTS_SUCCESS:
      return { ...state, loading: false, agreements: action.payload || [] };

    case actionTypes.SAVE_AGREEMENT_SUCCESS:
    case actionTypes.UPDATE_AGREEMENT_SUCCESS:
      return {
        ...state,
        saving: false,
        agreements: upsertByAgreementType(state.agreements, action.payload),
      };

    case actionTypes.DELETE_AGREEMENT_SUCCESS:
      return {
        ...state,
        saving: false,
        agreements: state.agreements.filter(
          (a) => a?._id !== action.payload?._id && a?.agreementType !== action.payload?.agreementType
        ),
      };

    case actionTypes.READ_CONSENT_ANALYTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        analytics: {
          data: action.payload?.data || [],
          summary: action.payload?.summary || null,
        },
      };

    case actionTypes.READ_CONSENT_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        consentUsers: action.payload?.data || [],
        consentUsersMeta: {
          page: action.payload?.page || 1,
          limit: action.payload?.limit || 20,
          totalRecords: action.payload?.totalRecords || 0,
        },
      };

    case actionTypes.READ_CONSENT_ENTITY_ANALYTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        entityAnalytics: {
          data: action.payload?.data || [],
          summary: action.payload?.summary || null,
        },
      };

    case actionTypes.READ_CONSENT_ENTITY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        entityDetails: action.payload?.data || [],
        entityDetailsMeta: {
          page: action.payload?.page || 1,
          limit: action.payload?.limit || 20,
          totalRecords: action.payload?.totalRecords || 0,
        },
      };

    case actionTypes.SAVE_CONSENT_SUCCESS:
      return { ...state, saving: false };

    case actionTypes.READ_ACTIVE_AGREEMENTS_FAILURE:
    case actionTypes.READ_AGREEMENTS_FAILURE:
    case actionTypes.READ_CONSENT_ANALYTICS_FAILURE:
    case actionTypes.READ_CONSENT_USERS_FAILURE:
    case actionTypes.READ_CONSENT_ENTITY_ANALYTICS_FAILURE:
    case actionTypes.READ_CONSENT_ENTITY_DETAILS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case actionTypes.SAVE_AGREEMENT_FAILURE:
    case actionTypes.UPDATE_AGREEMENT_FAILURE:
    case actionTypes.DELETE_AGREEMENT_FAILURE:
    case actionTypes.SAVE_CONSENT_FAILURE:
      return { ...state, saving: false, error: action.payload };

    default:
      return state;
  }
};

export default agreementsReducer;
